import { createStore } from 'vuex'
import auth from '@/store/auth.js'
import deals from '@/store/deals.js'
import cards from '@/store/cards.js'
import user from '@/store/userProfile.js'

export default createStore({
  state: {
    isPopUpActive: false,
    popUpVar: 0,
    loading: false
  },
  getters: {
  },
  mutations: {
    showLoader: (state, value) => {
      state.loading = value
    },
    popUpVarChange: (state, value) => {
      state.popUpVar = value
      state.isPopUpActive = true
    },
    closePopUp: (state) => {
      state.popUpVar = 0
      state.isPopUpActive = false
    }
  },
  actions: {
  },
  modules: {
    auth, deals, cards, user
  }
})
